import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * HomeRedirect component redirects to the appropriate home page based on user type
 * - Parents: /parent/home
 * - Students: /student/home
 */
const HomeRedirect: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isParent = user.user_type?.name === 'parent';
  return <Navigate to={isParent ? '/parent/home' : '/student/home'} replace />;
};

export default HomeRedirect;
